import { memo, useMemo } from 'react';

import { useShallow } from 'zustand/react/shallow';
import { useMediaQuery } from '@mui/material';

import { OLoader } from '@src/shared';
import HLSVideoPlayer from '../HLSVideoPlayer';
import VideosContainerMobile from './mobile/VideosContainerMobile';
import VideosContainerScreen from './screen/VideosContainerScreen';

import { useRoomActionsStore, useVideoStreamStore, useWebinarRoomStore } from '@src/stores';

import { EUserType } from '@src/types';

import styles from './videosContainer.module.scss';
import cn from 'classnames';
import { useRoomContext } from '@src/contexts';

const VideosContainer = () => {
  const isMobile = useMediaQuery('(max-width: 768px)');
  const { isPipActive } = useRoomActionsStore(
    useShallow((state) => ({
      isPipActive: state.pipSettings.isActive,
    }))
  );

  const { isFullyJoined } = useRoomContext();

  const { userType, viewerHLS } = useWebinarRoomStore(
    useShallow((state) => ({
      viewerHLS: state.streamDetails?.viewerHLS,
      userType: state.attendeeDetails?.user.type,
    }))
  );

  const isViewerMode = useMemo(() => !userType || userType === EUserType.ATTENDEE, [userType]);

  if (isViewerMode && viewerHLS) {
    return (
      <div className={cn(styles.viewModeContainer, { [styles.mobile]: isPipActive })}>
        <HLSVideoPlayer src={viewerHLS} />
      </div>
    );
  } else if (isFullyJoined) {
    return <>{isMobile ? <VideosContainerMobile /> : <VideosContainerScreen />}</>;
  }
  return <OLoader absolute={false} />;
};

export default memo(VideosContainer);
